var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGlassTube = function SvgGlassTube(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13C9.5 13.663 9.23661 14.2989 8.76777 14.7678C8.29893 15.2366 7.66304 15.5 7 15.5C6.33696 15.5 5.70107 15.2366 5.23223 14.7678C4.76339 14.2989 4.5 13.663 4.5 13V0.5H9.5V13Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5H3",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 5.5C7.8163 5.5 7.87989 5.52634 7.92678 5.57322C7.97366 5.62011 8 5.6837 8 5.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.75C7.5 5.6837 7.52634 5.62011 7.57322 5.57322C7.62011 5.52634 7.6837 5.5 7.75 5.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6C7.6837 6 7.62011 5.97366 7.57322 5.92678C7.52634 5.87989 7.5 5.8163 7.5 5.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.75C8 5.8163 7.97366 5.87989 7.92678 5.92678C7.87989 5.97366 7.8163 6 7.75 6",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.5C6.3163 8.5 6.37989 8.52634 6.42678 8.57322C6.47366 8.62011 6.5 8.6837 6.5 8.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.75C6 8.6837 6.02634 8.62011 6.07322 8.57322C6.12011 8.52634 6.1837 8.5 6.25 8.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9C6.1837 9 6.12011 8.97366 6.07322 8.92678C6.02634 8.87989 6 8.8163 6 8.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.75C6.5 8.8163 6.47366 8.87989 6.42678 8.92678C6.37989 8.97366 6.3163 9 6.25 9",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.5C7.3163 11.5 7.37989 11.5263 7.42678 11.5732C7.47366 11.6201 7.5 11.6837 7.5 11.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.75C7 11.6837 7.02634 11.6201 7.07322 11.5732C7.12011 11.5263 7.1837 11.5 7.25 11.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12C7.1837 12 7.12011 11.9737 7.07322 11.9268C7.02634 11.8799 7 11.8163 7 11.75",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.75C7.5 11.8163 7.47366 11.8799 7.42678 11.9268C7.37989 11.9737 7.3163 12 7.25 12",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5H4.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.5H2.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5V9.5",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.5C12.5 3.76522 12.6054 4.01957 12.7929 4.20711C12.9804 4.39464 13.2348 4.5 13.5 4.5C13.7652 4.5 14.0196 4.39464 14.2071 4.20711C14.3946 4.01957 14.5 3.76522 14.5 3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5C13.2348 2.5 12.9804 2.60536 12.7929 2.79289C12.6054 2.98043 12.5 3.23478 12.5 3.5Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlassTube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glass-tube.8d3384d0.svg";
export { ForwardRef as ReactComponent };